
namespace TabAurous.ProductDevelopment {

    @Serenity.Decorators.registerClass()
    export class PDQuotationItemsGrid extends Serenity.EntityGrid<PDQuotationItemsRow, any> {
        protected getColumnsKey() { return 'ProductDevelopment.QuotationItems'; }
        protected getDialogType() { return PDQuotationItemsDialog; }
        protected getIdProperty() { return PDQuotationItemsRow.idProperty; }
        protected getInsertPermission() { return PDQuotationItemsRow.insertPermission; }
        protected getLocalTextPrefix() { return PDQuotationItemsRow.localTextPrefix; }
        protected getService() { return PDQuotationItemsService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
            this.slickGrid.setOptions({ rowHeight: 30 });

        }

    }
}